import { InvestmentsService } from './../../investments.service';
import { Investment } from './../models/investment';
import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { AppEventDispatcher } from '../../../../utils/AppEventDispatcher';
import { EventTypes } from '../../../../shared/EventTypes';
import { Router, ActivatedRoute } from '@angular/router';
import { AutenticationEventType } from '../../../../autentication/autentication.event.type';
import { Auth } from '../../../../autentication/Auth';

@Component({
	selector: 'app-investment-detail',
	templateUrl: './investment-detail.component.html',
	styleUrls: ['./investment-detail.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class InvestmentDetailComponent implements OnInit, OnDestroy {

	public investment: Investment = new Investment();

	constructor(private router: Router, private route: ActivatedRoute, private investmentService: InvestmentsService) { }

	ngOnInit() {
		AppEventDispatcher.listen(AutenticationEventType.ACCOUNT.CHANGE_ACCOUNT, () => {
			this.router.navigate(['investimentos/extrato']);
		});

		this.route.params.subscribe(data => {
			this.getRouteInvestmentId(data);
		});
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(AutenticationEventType.ACCOUNT.CHANGE_ACCOUNT);
	}

	getRouteInvestmentId(data) {

		this.preload(true);

		this.investmentService.getInvestment(data.id).subscribe( investment => {
			this.investment = investment;
			this.preload(false);
		});

	}

	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD,
			{element: '[data-component="investment-detail"] .content', show: active, delay: delay});
	}

	sendForm(event) {
		this.router.navigate(['investimentos/extrato/resgate/' + this.investment.number]);
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/investments/investments-extract/investment-detail/investment-detail.component.ts